import { z } from 'zod';
import { moneySchema, provinceCodeSchema } from './common.js';

/**
 * Delivery (CLAUDE.md §3 `delivery`, "v1 min"): shipping fee is a
 * merchant-defined per-province price table. No auto-calculation, no carrier
 * APIs — those are v2 (VET / J&T / GrabExpress).
 */

export const shippingRateSchema = z.object({
  id: z.string().uuid(),
  provinceCode: provinceCodeSchema,
  price: moneySchema,
  isActive: z.boolean(),
  /** Orders at or above this subtotal ship free. Null = never free. */
  freeAboveAmount: z.number().int().min(0).nullable(),
  etaText: z.object({ km: z.string().max(60), en: z.string().max(60) }).nullable(),
});
export type ShippingRateDto = z.infer<typeof shippingRateSchema>;

export const upsertShippingRatesSchema = z.object({
  rates: z
    .array(
      z.object({
        provinceCode: provinceCodeSchema,
        priceAmount: z.number().int().min(0),
        isActive: z.boolean().default(true),
        freeAboveAmount: z.number().int().min(0).nullable().optional(),
        etaText: z
          .object({ km: z.string().max(60).default(''), en: z.string().max(60).default('') })
          .nullable()
          .optional(),
      }),
    )
    .max(30),
});

export const shipmentSchema = z.object({
  id: z.string().uuid(),
  orderId: z.string().uuid(),
  carrier: z.string().nullable(),
  trackingCode: z.string().nullable(),
  codAmount: moneySchema.nullable(),
  status: z.enum(['pending', 'shipped', 'delivered', 'returned']),
  shippedAt: z.string().datetime().nullable(),
  deliveredAt: z.string().datetime().nullable(),
});
export type ShipmentDto = z.infer<typeof shipmentSchema>;

export const upsertShipmentSchema = z.object({
  carrier: z.string().max(60).nullable().optional(),
  trackingCode: z.string().max(60).nullable().optional(),
  status: z.enum(['pending', 'shipped', 'delivered', 'returned']).optional(),
});
